import { ZodError, z } from 'zod';
import { trackError } from '@libs/analytics';
import type { ForgotPasswordForm } from './type';

export const emailRequiredMsg = 'Email address is required';
export const emailNotValidMsg = 'Enter a valid email address';

const forgotPasswordSchema = z
    .object({
        email: z
            .string()
            .trim()
            .refine(data => data !== '', {
                message: emailRequiredMsg,
            })
            .refine(
                email =>
                    email === '' || z.string().email().safeParse(email).success,
                {
                    message: emailNotValidMsg,
                }
            ),
    })
    .strict();

export const parseForgotPasswordForm = (
    values: ForgotPasswordForm
): ZodError | undefined => {
    try {
        forgotPasswordSchema.parse(values);
    } catch (error) {
        if (error instanceof ZodError) {
            return error;
        }
    }
    return undefined;
};

export const trackForgotPasswordFormErrors = (values: ForgotPasswordForm) => {
    const error = parseForgotPasswordForm(values);
    if (error) {
        const { fieldErrors } = error.formErrors;

        const errorMessages = Object.values(fieldErrors)
            .flat()
            .filter(Boolean)
            .join(' | ');

        trackError('reset-password', errorMessages);
    }
};

export const validateForgotPassword = (
    values: ForgotPasswordForm
): { [key: string]: string[] | undefined } | undefined => {
    const error = parseForgotPasswordForm(values);
    return error?.formErrors.fieldErrors;
};
